import styled from 'styled-components';

export const StyledUserPanelStudents = styled.div`
    width: 100%;
    height: 100%;
`;
